export default __webpack_public_path__ + "static/media/informasi-desktop.d69e60d7.png";